export default "__VITE_ASSET__vYfCey7x__"